import type {
  LogistEtrnState,
  LogistInboxStatus,
  LogistOrder,
  LogistTrip,
} from '@entities/logistics';

/**
 * Поле «дата и время» браузера понимает только «ГГГГ-ММ-ДДTчч:мм» в местной
 * зоне, а на сервер время уходит в UTC. Две функции ниже переводят туда и
 * обратно, чтобы кладовщик вводил своё время, а в документ попадало верное.
 */
export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInput(value: string): string | null {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

export function apiErr(e: unknown): string {
  if (e && typeof e === 'object' && 'data' in e) {
    const d = (e as { data?: unknown }).data;
    if (d && typeof d === 'object' && 'error' in d) return String((d as { error: unknown }).error);
  }
  return 'ошибка запроса';
}

export function orderLabel(o: LogistOrder): string {
  const cargo = o.cargo_name ?? 'заказ';
  const to = o.unloading_address ?? o.consignee_name ?? '';
  return `${cargo}${to ? ` → ${to}` : ''}${o.source_order_id ? ` (№ ${o.source_order_id})` : ''}`;
}

export function tripLabel(t: LogistTrip): string {
  const n = t.seq_no != null ? `Ходка № ${t.seq_no}` : 'Рейс';
  return `${n}${t.cargo_name ? ` · ${t.cargo_name}` : ''}`;
}

export function stateTone(s: LogistEtrnState): 'ok' | 'bad' | 'muted' | 'warn' {
  if (s === 'submitted') return 'ok';
  if (s === 'error') return 'bad';
  if (s === 'revoked') return 'warn';
  return 'muted';
}

export function inboxTone(s: LogistInboxStatus): 'ok' | 'bad' | 'muted' | 'warn' {
  if (s === 'linked') return 'ok';
  if (s === 'failed') return 'bad';
  if (s === 'skipped') return 'warn';
  return 'muted';
}
